import React, { useEffect, useState } from "react";
import { BaseState, StateKeys } from "../../redux/states/main.state";
import {
  ClassResponse,
  CourseResponse,
  TestResponse,
} from "../../services/api.response.service";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Languages from "../Languages";
import {
  AppState,
  CheckContentProviderIdExist,
  getLanguage,
  getLanguageByDefault,
  InfoLogger,
  getContentProviderId,
} from "../../services/app.service";
import { RouteEndpoints } from "../../services/route.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import Api from "../../services/api.service";
import { Mixpanel } from "../../services/mixpanel";

interface props {
  classDetails?: ClassResponse;
}

const SubscribeAccessButton = ({ classDetails }: props) => {
  const getLanguage = getLanguageByDefault();
  const dispatch = useDispatch();

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const { ecampus_id } = useSelector(
    (state: IRootState) => state.setting.user!,
  );

  const subscribe = async (classId: number | undefined) => {
    if (!classId) return;
    if (!ecampus_id) return (window.location.href = RouteEndpoints.SIGN_IN);

    const subscribed = classDetails?.is_subscribed;
    if (!subscribed) {
      const resObj = subscribed
        ? await Api.unsubscribeClass(classId)
        : await Api.subscribeClass(classId);
      if (resObj) {
        // console.log("the content",resObj.data.data);
        Mixpanel.track(
          subscribed ? "Unsubscribe from a Class" : "Subscribe to Class",
          {
            class_id: classDetails?.id,
            class_name: classDetails?.name,
            user_id: currentUser.id,
            ...(classDetails?.content_provider_id
              ? { content_provider_id: classDetails?.content_provider_id }
              : {}),
          },
        );
      }
    }
    // console.log("Mixpanel - subscribe from a Class", classDetails?.id, classDetails?.name);

    if (
      !classDetails?.has_paid &&
      // !subscribed &&
      classDetails?.payment_url &&
      !classDetails.is_free
    ) {
      Mixpanel.track("Class Payment link", {
        class_id: classDetails?.id,
        class_name: classDetails?.name,
        user_id: currentUser.id,
        ...(CheckContentProviderIdExist()
          ? { content_provider_id: getContentProviderId() }
          : {}),
      });

      window.location.href = classDetails?.payment_url;
    } else {
      window.location.reload();
    }
  };

  const getMessage = () => {
    let msg = classDetails?.is_subscribed
      ? getLanguage.unSubscribe
      : getLanguage.subscribe;

    if (!classDetails?.is_subscribed && classDetails?.is_free) {
      // msg = getLanguage.subscribe;
      // msg = getLanguage.payJoinClass;
      msg = "Join this class for FREE";
    } else if (
      (!classDetails?.is_subscribed && !classDetails?.has_paid) ||
      (classDetails?.is_subscribed && !classDetails?.has_paid)
    ) {
      // msg = getLanguage.payJoinClass;
      msg = "Pay to join this class";
    }

    return msg;
  };

  return (
    <>
      {" "}
      <section
        id="SubscribeAccessButton"
        className="align-items-center"
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        {!CheckContentProviderIdExist() &&
          // (ecampus_id && classDetails
          //     && !classDetails.is_subscribed
          // ) ?

          (ecampus_id &&
          classDetails &&
          // && !classDetails.is_subscribed
          (!classDetails?.is_subscribed ||
            (classDetails?.is_subscribed && !classDetails?.has_paid)) ? (
            <>
              <Button
                type="button"
                className="btn btn-primary ec-btn"
                onClick={() => subscribe(classDetails?.id)}
                // disabled={
                // sPageState ===
                // AppState.LOADING
                //}
              >
                {/*{*/}
                {/*    // sPageState ===*/}
                {/*    AppState.LOADING && (*/}
                {/*        <Spinner*/}
                {/*            animation={"border"}*/}
                {/*            size={"sm"}*/}
                {/*            className="me-1"*/}
                {/*        />*/}
                {/*    )}*/}
                <>{getMessage()}</>
              </Button>
              <br />
              <small>Use a promo code if you have one.</small>
            </>
          ) : (
            // (
            //     <>
            //         <a
            //             href={RouteEndpoints.SIGN_IN}
            //             className="text-decoration-none btn btn-primary"
            //             rel="noreferrer"
            //         >
            //             {getLanguage.signIn}
            //         </a>
            //     </>
            //
            // )
            ""
          ))}
      </section>{" "}
    </>
  );
};

export default SubscribeAccessButton;
